import { useCartStateSelector } from './useCartStateSelector';

export function useCartSummary() {
  const orderId = useCartStateSelector<number | undefined>(state => {
    return state?.context?.currentOrder?.id;
  });

  const positionCount = useCartStateSelector<number | undefined>(state => {
    const filteredCount = state?.context?.currentOrder?.normalPositions?.reduce((sum, group) => {
      return sum + group.positions.length;
    }, 0);

    const profitPlusCount = state?.context?.currentOrder?.profitPlusPositions?.reduce((sum, group) => {
      return sum + group.positions.length;
    }, 0);

    return (filteredCount ?? 0) + (profitPlusCount ?? 0);
  });

  const externalPositionCount = useCartStateSelector<number | undefined>(state => {
    const count = state?.context?.currentOrder?.externalGroupedPositions?.reduce((sum, group) => {
      return sum + group.externalPositions.length;
    }, 0);

    return count ?? 0;
  });

  const total = useCartStateSelector<number | undefined>(state => {
    return state?.context?.currentOrder?.total;
  });

  const totalDiscount = useCartStateSelector<number | undefined>(state => {
    return state?.context?.currentOrder?.totalDiscount;
  });

  const amountNeededForMinimalOrder = useCartStateSelector<number | undefined>(state => {
    return state?.context?.currentOrder?.amountNeededForMinimalOrder;
  });

  const isOciOrder = useCartStateSelector<boolean>(state => state?.context?.currentOrder?.creationSystem === 'OCI');

  const desiredDeliveryDate = useCartStateSelector<Date | undefined>(
    state => state?.context?.currentOrder?.desiredDeliveryDate
  );
  
  return {
    orderId,
    positionCount,
    externalPositionCount,
    total,
    totalDiscount,
    isOciOrder,
    amountNeededForMinimalOrder,
    desiredDeliveryDate
  };
}
